//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import loadmore from '@/components/ui/loadmore';
import navbar from '@/components/ui/navbar';
import cardbox from '@/components/ui/cardbox';

export default {
    components: {loadmore,cardbox,navbar},
    data(){
        return {
            listData: {
                current_page: 1,
                total: 0,
                per_page: 50,
                data: [],
            },
        }
    },
    methods:{

        // 查询推荐人列表
        initUserInfo(){

            const opts = {
                url: api.myReferrerList,
                data: {
                    page: 1,
                    size: 100,
                },
                type: 'get'
            }
            common.query(opts).then(res=>{
                this.listData = res.data;
            },res=>{
                this.$vux.toast.text(res.message);
            });

        },

    },
    mounted(){

        this.initUserInfo();

    },
}




// WEBPACK FOOTER //
// ./src/views/member/referList.vue